import React from 'react';
import { cn } from '../../../../utils/styles';
import InstitutionFooter from '../FinancialInstitution/Footer';

interface GuidanceAuthLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  contentClassName?: string;
}

function GuidanceAuthLayout({ children, className, contentClassName, ...props }: GuidanceAuthLayoutProps) {
  return (
    <div className={cn(['guidance w-screen min-h-screen', className])} {...props}>
      <div className={cn('min-h-[86vh]', contentClassName)}>{children}</div>

      <InstitutionFooter />
    </div>
  );
}

GuidanceAuthLayout.defaultProps = {
  contentClassName: undefined,
};

export default GuidanceAuthLayout;
